// Stable per-device signals that strengthen the server-side device fingerprint.
// Browsers cannot expose MAC addresses, so we combine hardware/browser entropy
// (screen, platform, CPU, memory, touch, language, canvas rendering) with the
// User-Agent on the backend to tell apart devices that share the same browser.

const fnv1a = (str) => {
  let h = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return (h >>> 0).toString(16).padStart(8, '0');
};

const canvasHash = () => {
  try {
    const c = document.createElement('canvas');
    c.width = 120;
    c.height = 24;
    const ctx = c.getContext('2d');
    ctx.textBaseline = 'top';
    ctx.font = '13px Arial';
    ctx.fillStyle = '#f60';
    ctx.fillRect(2, 2, 60, 18);
    ctx.fillStyle = '#069';
    ctx.fillText('Ensue~fp!2.0', 4, 4);
    return fnv1a(c.toDataURL());
  } catch {
    return '0';
  }
};

let _signals = null;

/** Compact, stable, ASCII-safe signal string sent as the X-Device-Signals header. */
export const getDeviceSignals = () => {
  if (_signals !== null) return _signals;
  try {
    const parts = [
      `plt:${navigator.userAgentData?.platform || navigator.platform || ''}`,
      `cpu:${navigator.hardwareConcurrency || 0}`,
      `mem:${navigator.deviceMemory || 0}`,
      `tch:${navigator.maxTouchPoints || 0}`,
      `lng:${navigator.language || ''}`,
      `cnv:${canvasHash()}`,
    ];
    _signals = parts.join('|').replace(/[^\x20-\x7E]/g, '').slice(0, 400);
  } catch {
    _signals = '';
  }
  return _signals;
};
